/**
 * Emit hosts for the `audio` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type AudioWarningEventProps } from '@/models/analytics/features/audio';

export function audioWarningAccepted(props: AudioWarningEventProps) {
  track({
    event_name: TrackingEventName.AudioWarningAccepted,
    props,
    options: { amplitude: false },
  });
}

export function audioWarningViewed(props: AudioWarningEventProps) {
  track({
    event_name: TrackingEventName.AudioWarningViewed,
    props,
    options: { amplitude: false },
  });
}
